import React from 'react';

const PenalChargeDetailsDialogUI = ({ isOpen, onClose, details }) => {
  if (!details) return null;

  // Split by line to extract individual clauses
  const clauseList = details.split(/\r?\n/).filter(clause => clause.trim() !== '');

  return (
    <div className="popup" style={isOpen ? { display: 'flex' } : { display: 'none' }}>
      <div className="popup-inner">
        <div className="g_flex_h">
          <h2>Compliance Clauses</h2>
          <button
            style={{ border: 'none', background: 'none', fontSize: '24px', cursor: 'pointer' }}
            onClick={onClose}
          >
            &times;
          </button>
        </div>

        <table className="popup-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Clause</th>
            </tr>
          </thead>
          <tbody>
            {clauseList.map((clause, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{clause}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PenalChargeDetailsDialogUI;
